export const PROCEED_TO_CHECKOUT = 'Proceed to Checkout';
export const KEEP_SHOPPING = 'Keep shopping';
export const CLOSE_BAG_LABEL = 'Close bag preview';
export const BACK_BAG = (itemsNumber: number) => `Bag (${itemsNumber})`;
